export default "__VITE_ASSET__357a1c78__"